/**
 * 事件管理模块统一导出
 */

export { eventBus, EventBus } from "./EventBus";
export type { TrackEvent, EventInterceptor, EventListener } from "./EventBus";
